var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mib-ad-container",on:{"click":function($event){return _vm.openLink()}}},[_c('img',{attrs:{"src":_vm.mibAdImage,"alt":"mib-ad"}}),_c('span',{staticClass:"mib-ad"},[_vm._v(_vm._s(_vm.buttonName))])])}
var staticRenderFns = []

export { render, staticRenderFns }